import React, { Component } from 'react'

export class Expenditure extends Component {
    render() {
        return (
                <div className="box">
                <div className="box-body">
                    <div className="box-header">
                        <h3 className="box-title">Expenditure</h3>
                    </div>
                    <div className="col-md-12 table-responsive">
                        <table className="table table-bordered">
                            <thead>
                            <tr className="bg-gray">
                                <th>For FY</th>
                                <th>Action Plan Allocation</th>
                                <th>Cumulative Exp. (Workorder related)</th>
                                <th>Cumulative exp(Other Payment)</th>
                                <th>Total Exp (Work Order + Other)</th>
                                <th>Balance</th>
                            </tr>
                            </thead>
                            <tfoot>
                            <tr>
                                <th colspan="2" className="text-right">Total</th>
                                <th className="text-right"></th>
                                <th className="text-right"></th>
                                <th className="text-right"></th>
                                <th className="text-right"></th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="col-md-12">
                        <div className="alert alert-danger" role="alert">
                            <h3>If BG/FDR entry is not there than the Expenditure page shall get locked for entry</h3>
                        </div>
                        <div id="error_msg_display_board"></div>
                        <form action="partworksdetails/partworkbill">
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Bill Number</label> 
                                <input type="text" name="bill_no" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Bill Date</label> 
                                <input type="text" placeholder="DD-MM-YYYY" name="billdate" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Type</label> 
                                <select className="form-control" name="bill_type">
                                    <option value="W">Work Order Related Payment</option>
                                    <option value="O">Other Payment</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Description</label> 
                                <input type="text" name="billdescription" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Amount</label> 
                                <input type="text" name="billamount" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-4" style={{ padding: '2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </form>	
                </div>
                <h3 className="text-center">Bill List</h3>
                <div className="col-md-12 table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr className="bg-gray">
                            <th>Bill No.</th>
                            <th>Bill Date</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Edit</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                </div>
                </div>
        )
    }
}

export default Expenditure
